import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25 23.25H3.75a1.5 1.5 0 0 1-1.5-1.5V5.25",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 20.25H6.75a1.5 1.5 0 0 1-1.5-1.5V2.25",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.75 15.75a1.5 1.5 0 0 1-1.5 1.5H9.75a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h7.629a1.5 1.5 0 0 1 1.06.439l2.872 2.872a1.5 1.5 0 0 1 .439 1.06V15.75Z",
			fill: "#531DAB",
			stroke: "#531DAB",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M17.25%2023.25H3.75a1.5%201.5%200%200%201-1.5-1.5V5.25%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M20.25%2020.25H6.75a1.5%201.5%200%200%201-1.5-1.5V2.25%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M21.75%2015.75a1.5%201.5%200%200%201-1.5%201.5H9.75a1.5%201.5%200%200%201-1.5-1.5V2.25a1.5%201.5%200%200%201%201.5-1.5h7.629a1.5%201.5%200%200%201%201.06.439l2.872%202.872a1.5%201.5%200%200%201%20.439%201.06V15.75Z%22%20fill%3D%22%23531DAB%22%20stroke%3D%22%23531DAB%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
